import openModal from 'App/services/Modal';

/** Sales › Website chats with the chat's record view open, for the new tab a modified click opens. */
export const websiteChatPath = (chatId: number) => `/website-chats?chatId=${chatId}`;

/** Sales › Website chats on one bot's chats: the list's Chatbot filter, applied by the page. */
export const chatbotChatsPath = (agentId: number) => `/website-chats?chatbotId=${agentId}`;

type FromList = {
	/** The list it was opened from, for Previous / Next; without one there is none. */
	chatIds: number[];
	total?: number;
	onNavigate?: (chatId: number) => void;
	onClose?: () => void;
};

/**
 * Every link to a website chat opens its record view on top of where the link
 * is (WEB-13681), so closing it comes back there - to the to-do or phone call
 * drawer still open under it. ui-3: ui-3/src/lib/websiteChatLink.ts.
 */
export const openWebsiteChat = (chatId: number, list?: FromList) => openModal('WebsiteChat', { chatId, ...list });
